import { FC } from "react"
import { LOsTableWithImporter } from "../../loan-officers"
import { useIsAdmin } from "../../../hooks"

interface Props {
  brandId?: string
}

const BrandDetailsLoanOfficers: FC<Props> = ({ brandId }) => {
  const isAdmin = useIsAdmin()
  return (
    <div className="p-6 bg-white">
      <LOsTableWithImporter
        searchParams={{ brand_id: brandId }}
        hasMasqueradeIcon={isAdmin}
      />
    </div>
  )
}

export default BrandDetailsLoanOfficers
